module.exports = __webpack_public_path__ + "static/media/agrtucal-sceen.b05c3836.png";